<template>
  <div>
    <div v-if="ordersin" class="orders_">
      <div class="" :key="orderKey" v-for="(order, orderKey) in $store.state.orders">
        <div class="update-border container m4" v-if="$route.params.orderId ? $route.params.orderId === orderKey : !$route.params.orderId">
          <div class="flex wrap xs-font flexy between fill p8 b8 update">
            <router-link :to="`/orders/${orderKey}`" class="p4 white">Order ID: <b>{{orderKey}}</b></router-link>
            <div class="p4">Complete: <b>{{order.complete}}</b></div>
            <div class="p4">Total: <i class="fas fa-xs fa-dollar-sign"></i> <b>{{Number(order.total)}}</b></div>
            <div class="p4">Paid: <b>{{order.paid}}</b>
            <a href @click.prevent="resubmitPayment(order, orderKey)" v-if="order.paid === false || order.paid === 'EXPIRED' || order.paid === 'NEW'">
              <code class="l8">Update Payment</code>
              </a></div>
            <itime class="p4" :timestamp="order.timestamp"></itime>
          </div>
            <div class="flex wrap align-center" v-if="order.paid === 'NEW'">
              <a class="p4 fit flex" style="min-width: 240px;" v-if="order.payment" :href="`${order.payment.order.currency}:${order.payment.charge[order.payment.order.currency].wallet}?${order.payment.order.currency === 'ethereum' ? 'value' : 'amount'}=${order.payment.charge[order.payment.order.currency].amount}`"><img class="fill flex" v-if="order.qr" :src="order.qr" alt=""></a>
              <div class="flex wrap flexx">
                <span class="sm-font flex align-center">To complete this {{order.payment.order.currency.toUpperCase()}} transaction, tap or scan the QR code or manually send:</span>
                <span class="flex align-center wrap">
                  <b class="flex column fit p8" @click="$copyText(order.payment.charge[order.payment.order.currency].amount); $store.commit('point', {text: 'Amount copied!', header: order.payment.charge[order.payment.order.currency].amount, speed: 1200});">
                    <span><i class="r4" :class="$store.state.icons[order.payment.order.currency]"></i> {{order.payment.charge[order.payment.order.currency].amount}} <i class="far fa-copy fa-xs"></i></span>
                  </b> 
                  <span class="xs-font p8">to</span> 
                  <b class="flex column fit p8 break" @click="$copyText(order.payment.charge[order.payment.order.currency].wallet); $store.commit('point', {text: 'Address copied!', header: order.payment.charge[order.payment.order.currency].wallet, speed: 1200});"><span style="word-break: break-word;"><i :class="$store.state.icons.wallet + ' r8'"></i>{{order.payment.charge[order.payment.order.currency].wallet}} <i class="far fa-copy fa-xs"></i></span></b>
                </span>
              </div>
            </div>
          <div>
            <div :key="item.id" v-for="item in order.items" class="flex wrap p8 between">
              <div class="flex wrap align-center p4 flexy">
                <router-link :to="`/i/${item.type}/${item.iitemid}`" class="r8 flex fill"><b class="r4"><i :class="$store.state.icons[item.type]" class="r8"></i>{{item.itemTitle}}</b></router-link>
                <div class="xs-font flex between align-center flexy wrap">
                  <span>Item Status: <b class="r4">{{item.status}}</b></span>
                  <span><b class="r4"><i :class="`fa-xs fas fa-${item.purchase.currency.toLowerCase() === 'usd' ? 'dollar-sign' : ''}`"></i> {{item.purchase.cost}}</b> <i v-if="item.purchase['shipping and handling']">+ {{item.purchase['shipping and handling']}} s&h</i></span>
                  <span>Qty: <b class="r4">{{item.qty}}</b></span>
                  <div v-if="item.purchase.selectedVariations && Object.keys(item.purchase.selectedVariations).length > 0" class="flex wrap align-center r8">
                    <b class="r4">Variations:</b>
                    <span
                      v-for="(variation, varType) in item.purchase.selectedVariations"
                      :key="varType"
                      class="r4 xs-font"
                    >
                      {{varType}}: {{variation.name || variation}}
                      <span v-if="variation.description"> ({{variation.description}})</span>
                    </span>
                  </div>
                  <user class="b8" :userid="item.seller"></user>
                  <div class="flex xs-font align-center">
                    <span v-if="item.shipping.name" class="flex align-center wrap">
                      <b class="r16 xs-font">Ship to:</b> 
                      <span class="align-center r8">{{item.shipping.name}}</span>
                      <span :key="addyKey" v-for="(addy, addyKey) in item.shipping" class="flex align-center">
                        <span class="r8 flex align-center" v-if="addyKey !== 'name'"><span class="">{{addy}}</span></span>
                      </span>
                    </span>          
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span class="">Fetching orders...</span>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  
  export default {
    name: 'orders',
    data () {
      return {
        msg: 'orders bro',
        ordersin: false
      }
    },
    methods: {
      resubmitPayment(order, orderKey) {
        // Populate cart with order items and show checkout
        const cart = {};
        order.items.forEach((item, index) => {
          const cartKey = `${item.type}_${item.iitemid}_${index}`;
          cart[cartKey] = [
            item.type,
            item.iitemid,
            item.purchase,
            item.qty,
            item.seller,
            item.itemTitle
          ];
        });
        
        // Set cart in store
        if (this.$store.state.user[this.$store.state.auth.uid]) {
          Vue.set(this.$store.state.user[this.$store.state.auth.uid], 'cart', cart);
        }
        
        // Store the existing orderId so checkout knows to update instead of create
        this.$store.state.pendingOrderUpdate = {
          orderId: orderKey,
          existingOrder: order
        };
        
        // Show cart with checkout form
        this.$store.state.show.cart = true;
      }
    },
    mounted () {
      this.$store.dispatch('query', {
        type: 'orders',
        user: this.$store.state.auth.uid
      }).then(()=>setTimeout(()=>this.ordersin = true, 2000))
    }
  }
</script>